import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as RegionContent } from './Content.vue';

export interface RegionContentImage {
	url: string;
	credits?: string;
	class?: HTMLAttributes['class'];
}

export interface RegionContentInfo {
	title: string;
	content: string;
	class?: HTMLAttributes['class'];
}
export interface RegionContentProps {
	info: RegionContentInfo;
	images: RegionContentImage[];
	class?: HTMLAttributes['class'];
	contentIndex?: number;
	isLoading?: boolean;
}

export const propertyCardFooterTextsVariants = cva('font-medium ', {
	variants: {
		variant: {
			whiteBackground: 'text-primary-light-3',
			transparentBackground: 'text-white'
		},
		size: {
			sm: 'text-[12px] leading-[18px]',
			lg: 'text-[12px] leading-[18px] lg:text-[14px] lg:leading-[20px]'
		}
	},
	defaultVariants: {
		variant: 'whiteBackground',
		size: 'sm'
	}
});

export const regionWrapperVariants = cva('py-8 lg:py-15', {
	variants: {
		variant: {
			default: 'bg-secondary',
			reverse: 'bg-white'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export const regionGridContentVariants = cva(
	'col-span-2 flex h-full flex-col justify-center gap-3 lg:col-span-1',
	{
		variants: {
			variant: {
				default: 'lg:pr-6',
				reverse: 'lg:order-2 lg:pl-6'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export const regionGridImageGalleryVariants = cva(
	'hidden h-full items-end lg:flex',
	{
		variants: {
			variant: {
				default: 'lg:order-2',
				reverse: 'lg:order-1'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);
